var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplayOverflowNumber())?_c('v-chip',{staticClass:"text-bold pl-0 mt-1",attrs:{"color":"primary","text-color":"accent","disabled":"","pill":""}},[_vm._v(" "+_vm._s(_vm.getNumberOfOverflowTags())+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }